import { render, staticRenderFns } from "./CriterionInputRadio.vue?vue&type=template&id=da2b065a&scoped=true&"
import script from "./CriterionInputRadio.vue?vue&type=script&lang=js&"
export * from "./CriterionInputRadio.vue?vue&type=script&lang=js&"
import style0 from "./CriterionInputRadio.vue?vue&type=style&index=0&id=da2b065a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da2b065a",
  null
  
)

export default component.exports